import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { LegacyCertStatusData } from "@/hooks/queries/legacy-cert-types";

// GET /profile/legacy-cert (Story 16.3, Decision 3). The Profile cert card hydrates
// from this on load / after sign-in, so the Pending (and 16.4/16.5 Verified/Rejected)
// states survive a reload instead of living only in a POST response.
//
// `enabled` is caller-controlled: the card passes `userOrigin === "webapp_legacy"` so
// the query never fires for a non-legacy user (whose server would 403 anyway, AC8).

export const LEGACY_CERT_QUERY_KEY = "legacy-cert-status";

export function useLegacyCertStatus(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [LEGACY_CERT_QUERY_KEY],
    queryFn: () => apiFetch<LegacyCertStatusData>("/profile/legacy-cert"),
    enabled: options?.enabled ?? true,
  });
}
